import PropTypes from 'prop-types';
import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Button from '@mui/material/Button';
import { DialogChatbot } from './dialog-chatbot';
import CmsChatbot from './chatbot';
import { getSite } from '../../cms-api/user_acl';
import { useSiteContext } from '../../components/site/context/site-context';
import { useSettingsContext } from '../../components/settings/context/settings-context';

const ConfigChatComponent = forwardRef(({headerText = "設定編集チャット" }, ref) => {
  const [initialized, setInitialized] = useState(false);

  const { site, getConfigEditData } = useSiteContext();
  const settings = useSettingsContext();
  
  const aiChatbotRef = useRef({});
  const aiDialogRef = useRef({});
  
  useEffect(() => {
    aiChatbotRef.current = React.createRef();
    aiDialogRef.current = React.createRef();
    setInitialized(true);
  }, []);

  useImperativeHandle(ref, () => ({
    showDialog: () => {
      if (aiDialogRef.current && aiDialogRef.current.current) {
        aiDialogRef.current.current.showDialog();
      }
    },
  }));

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'} sx={{ mb: 3 }}>
      {initialized && (
        <>
          <Grid container spacing={3}>
            <Grid xs={12} md={12}>
              <Button 
                variant="contained" 
                color="primary"
                startIcon={
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8334 3.1001H4.16675C3.50371 3.1001 2.86782 3.36349 2.39898 3.83233C1.93014 4.30117 1.66675 4.93706 1.66675 5.6001V18.1001C1.667 18.2478 1.70649 18.3927 1.78117 18.5201C1.85584 18.6475 1.96303 18.7527 2.09175 18.8251C2.21629 18.8957 2.35692 18.933 2.50008 18.9334C2.64965 18.9334 2.79645 18.8931 2.92508 18.8168L6.66675 16.5501C6.80505 16.4678 6.96424 16.4272 7.12508 16.4334H15.8334C16.4965 16.4334 17.1323 16.17 17.6012 15.7012C18.07 15.2324 18.3334 14.5965 18.3334 13.9334V5.6001C18.3334 4.93706 18.07 4.30117 17.6012 3.83233C17.1323 3.36349 16.4965 3.1001 15.8334 3.1001ZM6.66675 10.6001C6.50193 10.6001 6.34081 10.5512 6.20377 10.4597C6.06673 10.3681 5.95992 10.2379 5.89685 10.0857C5.83378 9.9334 5.81727 9.76584 5.84943 9.60419C5.88158 9.44254 5.96095 9.29405 6.07749 9.17751C6.19404 9.06097 6.34252 8.9816 6.50417 8.94944C6.66582 8.91729 6.83338 8.93379 6.98565 8.99686C7.13792 9.05994 7.26807 9.16675 7.35964 9.30379C7.45121 9.44083 7.50008 9.60195 7.50008 9.76676C7.50008 9.98778 7.41228 10.1997 7.256 10.356C7.09972 10.5123 6.88776 10.6001 6.66675 10.6001ZM10.0001 10.6001C9.83526 10.6001 9.67415 10.5512 9.53711 10.4597C9.40006 10.3681 9.29325 10.2379 9.23018 10.0857C9.16711 9.9334 9.15061 9.76584 9.18276 9.60419C9.21491 9.44254 9.29428 9.29405 9.41083 9.17751C9.52737 9.06097 9.67585 8.9816 9.83751 8.94944C9.99916 8.91729 10.1667 8.93379 10.319 8.99686C10.4713 9.05994 10.6014 9.16675 10.693 9.30379C10.7845 9.44083 10.8334 9.60195 10.8334 9.76676C10.8334 9.98778 10.7456 10.1997 10.5893 10.356C10.4331 10.5123 10.2211 10.6001 10.0001 10.6001ZM13.3334 10.6001C13.1686 10.6001 13.0075 10.5512 12.8704 10.4597C12.7334 10.3681 12.6266 10.2379 12.5635 10.0857C12.5004 9.9334 12.4839 9.76584 12.5161 9.60419C12.5482 9.44254 12.6276 9.29405 12.7442 9.17751C12.8607 9.06097 13.0092 8.9816 13.1708 8.94944C13.3325 8.91729 13.5 8.93379 13.6523 8.99686C13.8046 9.05994 13.9347 9.16675 14.0263 9.30379C14.1179 9.44083 14.1667 9.60195 14.1667 9.76676C14.1667 9.98778 14.079 10.1997 13.9227 10.356C13.7664 10.5123 13.5544 10.6001 13.3334 10.6001Z" fill="white"/>
                  </svg>
                }
                onClick={() => {
                  if (aiDialogRef.current && aiDialogRef.current.current) {
                    aiDialogRef.current.current.showDialog();
                  }
                }}
                sx={{
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
              >
                設定編集をAIアシスタントに相談（α版）
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ display: 'none' }}>
            <DialogChatbot
              type="config-simple"
              ref={aiDialogRef.current}
              headerText={headerText}
              getSiteConfigData={getConfigEditData}
            />
            <CmsChatbot
              type="config-simple"
              ref={aiChatbotRef.current}
              headerText={headerText}
              getSiteConfigData={getConfigEditData}
              def_minimized
            />
          </Grid>
        </>
      )}
    </Container>
  );
});

ConfigChatComponent.propTypes = {
  headerText: PropTypes.string,
};

export default ConfigChatComponent;
